module.exports = __webpack_public_path__ + "img/deadplan.d43f6d8c.png";